class PhotoMarker {
    constructor(LatLngPosition, content){

        this.position = LatLngPosition;
        this.content = content;
        this.div = document.createElement('div');
        this.overlay = new google.maps.OverlayView();
        this.overlay.onAdd = this.onAdd.bind(this);
        this.overlay.draw = this.draw.bind(this);
        this.overlay.onRemove = this.remove.bind(this);

    }

    setMap(map){
        this.overlay.setMap(map);
    }

    addListener(action, callback){
        this.div.addEventListener(action, callback);
    }

    onAdd() {
        this.div.className = 'photoMarker';
        this.div.style.position = 'absolute';

        const panes = this.overlay.getPanes();
        panes.overlayImage.appendChild(this.div);

        if (typeof this.content === 'undefined') {
            return;
        }

        if (typeof this.content === 'string') {
            this.div.innerHTML = this.content;
        } else if (typeof this.content.tagName !== 'undefined') {
            try {
                this.div.appendChild(this.content);
            } catch (err) {
            }
        }
    }

    remove() {
        if (this.div) {
            this.div.parentNode.removeChild(this.div);
            this.div = null;
        }
    }

    draw() {
        const position = this.overlay.getProjection().fromLatLngToDivPixel(this.position);
        this.div.style.left = `${position.x - (this.div.offsetWidth / 2)}px`;
        this.div.style.top = `${position.y - (this.div.offsetHeight) - 8}px`;
    }

    getPosition() {
        return this.position;
    }

    getMarkerElement() {
        return this.div;
    }

}

export default PhotoMarker;